module.exports = __webpack_public_path__ + "static/media/CRAFT.d761c919.png";